'use client'

import { useTranslation } from '../../../context/ConfigContext'
import InputCheckbox from '../../Form/InputCheckbox'

export const SORT_BY_PERTINENCE = 1
export const SORT_BY_PRICE_ASC = 2
export const SORT_BY_PRICE_DESC = 3

export type SortByChoice =
  | typeof SORT_BY_PERTINENCE
  | typeof SORT_BY_PRICE_ASC
  | typeof SORT_BY_PRICE_DESC

type OrderProductsProps = {
  sortBy: SortByChoice

  onChange: (value: SortByChoice) => void
}
const OrderProducts = ({ sortBy, onChange }: OrderProductsProps) => {
  const t = useTranslation()
  return (
    <div className='orderproducts'>
      <ul className='orderproducts-fields'>
        <InputCheckbox
          id='orderby-pertinence'
          label={t('Relevance', {}, false)}
          value={SORT_BY_PERTINENCE}
          checked={sortBy === SORT_BY_PERTINENCE}
          onChange={() => onChange(SORT_BY_PERTINENCE)}
        />
        <InputCheckbox
          id='orderby-price-asc'
          label={t('Ascending price', {}, false)}
          value={SORT_BY_PRICE_ASC}
          checked={sortBy === SORT_BY_PRICE_ASC}
          onChange={() => onChange(SORT_BY_PRICE_ASC)}
        />
        <InputCheckbox
          id='orderby-price-desc'
          label={t('Descending price', {}, false)}
          value={SORT_BY_PRICE_DESC}
          checked={sortBy === SORT_BY_PRICE_DESC}
          onChange={() => onChange(SORT_BY_PRICE_DESC)}
        />
      </ul>
    </div>
  )
}

export default OrderProducts
